import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=1b846432&scoped=true"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=1b846432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b846432",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
